export const FETCH_ORGANISATION_DETAILS = 'organisationDetails/FETCH_ORGANISATION_DETAILS'
